// Proje Yönetimi tablosunun sütunları ve hücre yardımcıları. Anahtarlar
// Projects dokümanlarındaki alan adlarıdır; liste verisi formatValue'dan
// geçtiği için (useProjectDirectory) değerler metindir.
import { PROJECT_DESIGN } from '../../utils/projectDesign';

const PHASE_OPTIONS = [
  { value: 'Başlangıç', labelKey: 'projectManagement.phases.initiation' },
  { value: 'Planlama', labelKey: 'projectManagement.phases.planning' },
  { value: 'Yürütme', labelKey: 'projectManagement.phases.execution' },
  { value: 'İzleme ve Kontrol', labelKey: 'projectManagement.phases.monitoring' },
  { value: 'Kapanış', labelKey: 'projectManagement.phases.closing' },
  { value: 'Tamamlandı', labelKey: 'projectManagement.phases.completed' },
  { value: 'Faz I', labelKey: 'projectManagement.phases.phase1' },
  { value: 'Faz II', labelKey: 'projectManagement.phases.phase2' },
  { value: 'Faz III', labelKey: 'projectManagement.phases.phase3' },
  { value: 'Düşük Riskli Bilimsel Çalışma', labelKey: 'projectManagement.phases.lowRisk' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/II)', labelKey: 'projectManagement.phases.adaptive12' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/III)', labelKey: 'projectManagement.phases.adaptive13' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz II/III)', labelKey: 'projectManagement.phases.adaptive23' },
  { value: 'Sağlık Beyanlı Ürün/Yöntem Çalışması', labelKey: 'projectManagement.phases.healthClaim' },
  { value: 'Beşeri Tıbbi Ürünlerin Gözlemsel Çalışması', labelKey: 'projectManagement.phases.observational' },
  { value: 'Kök hücreler ile yapılan klinik araştırması', labelKey: 'projectManagement.phases.stemCell' },
];

const DESIGN_OPTIONS = [
  { value: PROJECT_DESIGN.DOUBLE_BLIND, labelKey: 'projectManagement.designs.doubleBlind' },
  { value: PROJECT_DESIGN.OPEN_LABEL, labelKey: 'projectManagement.designs.openLabel' },
  { value: PROJECT_DESIGN.HYBRID, labelKey: 'projectManagement.designs.hybrid' },
];

// `label`: Turkish header (Excel); `id`: projects.columns.<id>; `width` in px.
export const PROJECT_COLUMNS = {
  customer: { label: 'Müşteri', type: 'text', width: 200 },
  titleShort: { label: 'Başlık (Kısa)', type: 'text', width: 230 },
  projectPhase: { label: 'Proje Aşaması', type: 'select', width: 190, options: PHASE_OPTIONS },
  projectStatus: {
    label: 'Proje Durumu',
    type: 'select',
    width: 130,
    options: [
      { value: 'Aktif', labelKey: 'projectManagement.status.active' },
      { value: 'Pasif', labelKey: 'projectManagement.status.inactive' },
    ],
  },
  protocolNumber: { label: 'Protokol Numarası', type: 'text', width: 180 },
  ethicsCommitteeDate: { label: 'Etik Kurul Tarihi', type: 'date', width: 160 },
  ethicsCommitteeNumber: { label: 'Etik Kurul Numarası', type: 'text', width: 180 },
  ethicsCommitteePlace: { label: 'Etik Kurul Yeri', type: 'text', width: 200 },
  firstInvoiceDate: { label: 'İlk Fatura Tarihi', type: 'date', width: 160 },
  paymentFrequency: { label: 'Ödeme Sıklığı', type: 'text', width: 150 },
  projectCentersType: { label: 'Proje Merkezi Tipi', type: 'text', width: 170 },
  projectDesign: { label: 'Proje Design', type: 'select', width: 170, options: DESIGN_OPTIONS },
  projectDate: { label: 'Proje Tarihi', type: 'date', width: 140 },
  projectDepartment: { label: 'Proje Departmanı', type: 'text', width: 190 },
  projectDueDate: { label: 'Proje Bitiş Tarihi', type: 'date', width: 170 },
  coordinatorAcademician: { label: 'Koordinatör Akademisyen', type: 'text', width: 220 },
  sbFirstApprovalDate: { label: 'SB İlk Onay Tarihi', type: 'date', width: 170 },
  sbFirstApprovalNumber: { label: 'SB İlk Onay Numarası', type: 'text', width: 190 },
  sbProjectNumber: { label: 'SB Proje Numarası', type: 'text', width: 180 },
  titleLong: { label: 'Başlık (Uzun)', type: 'text', width: 320 },
  isCurrencyFixed: {
    label: 'Kur Sabitlemesi',
    type: 'select',
    width: 150,
    options: [
      { value: 'true', labelKey: 'projectManagement.yes' },
      { value: 'false', labelKey: 'projectManagement.no' },
    ],
  },
  fixedCurrencyRate: { label: 'Sabit Kur (Kaçtan?)', type: 'text', width: 170 },
};

export const COLUMN_KEYS = Object.keys(PROJECT_COLUMNS);

// İlk açılışta görünen sütunlar (eski varsayılanlar; geniş ekranı dolduruyor)
const HIDDEN_BY_DEFAULT = ['sbFirstApprovalDate', 'sbFirstApprovalNumber', 'sbProjectNumber', 'titleLong', 'isCurrencyFixed', 'fixedCurrencyRate'];
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, !HIDDEN_BY_DEFAULT.includes(key)]));

export const MIN_COLUMN_WIDTH = 96;

// Kimlik sütunları: tablonun başındaysalar yatay kaydırmada sabit kalırlar.
export const PINNED_COLUMNS = ['customer', 'titleShort'];

// Arama kutusunun baktığı alanlar
export const SEARCH_FIELDS = ['customer', 'titleShort', 'projectDepartment'];

const EMPTY_MARKERS = ['nan', 'nat', 'n/a', 'null', 'undefined'];

export const isEmptyValue = (value) =>
  value === null ||
  value === undefined ||
  value === '' ||
  Number.isNaN(value) ||
  (typeof value === 'string' && EMPTY_MARKERS.includes(value.trim().toLowerCase()));

export const displayValue = (value) => (isEmptyValue(value) ? '-' : String(value));

// Boolean alanlar listede 'true'/'false' metnine dönüşüyor; ikisini de kabul et
const isTrueFlag = (value) => value === true || value === 'true';
export const isTestProjectFlag = (project) => isTrueFlag(project?.isTestProject);
export const isFinishedFlag = (project) => isTrueFlag(project?.isFinished);
export const isCurrencyFixedFlag = (project) => isTrueFlag(project?.isCurrencyFixed);

/** Proje durumu boşsa (eski kayıt) "Aktif" sayılır. */
export const projectStatusOf = (project) => project?.projectStatus || 'Aktif';

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** 'YYYY-MM-DD' gün.ay.yıl olarak; başka biçimde kaydedilmiş değerler olduğu gibi. */
export const formatIsoDate = (value, locale = 'tr-TR') => {
  if (isEmptyValue(value)) return '-';
  const match = typeof value === 'string' ? value.trim().match(ISO_DATE) : null;
  if (!match) return String(value);
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).toLocaleDateString(locale);
};

const DAY_MS = 24 * 60 * 60 * 1000;

/** Bitiş tarihine kalan gün (geçmişse eksi); tarih okunamazsa null. */
export const daysUntilDue = (project) => {
  if (isEmptyValue(project?.projectDueDate)) return null;
  const due = new Date(project.projectDueDate);
  if (Number.isNaN(due.getTime())) return null;
  return Math.ceil((due.getTime() - Date.now()) / DAY_MS);
};

/** "Bitiş tarihi yaklaşanlar": bitiş tarihi bugün ile bir ay sonrası arasında (eski kural). */
export const isDueSoon = (project) => {
  if (!project?.projectDueDate) return false;
  const dueDate = new Date(project.projectDueDate);
  const today = new Date();
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
  return !Number.isNaN(dueDate.getTime()) && dueDate <= oneMonthFromNow && dueDate >= today;
};

/** Sütun başlığı (geçerli dilde). */
export const columnLabel = (t, key) => t(`projectManagement.columns.${key}`);

/** Bir seçeneğin geçerli dildeki adı. */
export const optionLabel = (t, option) => (option.labelKey ? t(option.labelKey) : option.label);

/** Seçimli sütunlarda bir değerin adı; listede yoksa değerin kendisi. */
export const getFilterValueLabel = (t, key, value) => {
  const option = PROJECT_COLUMNS[key]?.options?.find((item) => String(item.value) === String(value));
  return option ? optionLabel(t, option) : String(value);
};

const hasFilterValue = (value) => value !== undefined && value !== null && String(value) !== '';

/**
 * Bir sütun filtresinin listeye uygulanıp uygulanmadığı: seçim ve tarih
 * filtreleri her değerde, metin filtreleri en az 3 karakterde devreye girer
 * (useProjectDirectory'deki filtreleme ile aynı kural).
 */
export const getFilterState = (key, value) => {
  if (!hasFilterValue(value)) return 'off';
  if (PROJECT_COLUMNS[key]?.type !== 'text') return 'applied';
  return String(value).trim().length >= 3 ? 'applied' : 'pending';
};

/** İki harf: proje kodundan ya da müşteriden ("ABC İLAÇ" → "Aİ"). */
export const initialsOf = (text, fallback = 'PR') => {
  const words = String(text || '').split(/[\s\-_/]+/).filter((word) => /[\p{L}\p{N}]/u.test(word));
  if (words.length === 0) return fallback;
  const letters = words.length === 1 ? words[0].slice(0, 2) : `${words[0][0]}${words[1][0]}`;
  return letters.toLocaleUpperCase('tr-TR');
};
